<template lang="pug">
SlideInPanel(:isOpen="sidePanelIsOpen" @close="$emit('close')")
  SlideInBaseTemplate(
    v-if="focusedItem"
    :title="focusedItem.Description"
    :allowEdit="allowEdit"
    @edit="event => $emit('edit', {item: focusedItem, event})"
    @close="$emit('close')"
    )
    BriqTable.dense
      tbody
        tr
          td.bold Key
          td {{ focusedItem.Key }}
        tr
          td.bold Name
          td {{ focusedItem.Description }}
        tr
          td.bold Slug
          td {{ focusedItem.Slug }}
        tr
          td.bold ResourceType
          td {{ focusedItem.ResourceType }}
        tr
          td.bold Capacity
          td(data-test-id="capacity") {{ capacity }}
        tr
          td.bold Exclusivity
          td(data-test-id="exclusivity") {{ exclusive }}
        tr
          td.bold Allows scheduling
          td(data-test-id="allow-scheduling") {{ allowsScheduling }}
        tr
          td.bold Default timeslot duration
          td(data-test-id="default-timeslot-duration") {{ defaultTimeslotDuration }}
</template>

<script>
import SlideInPanel from '@v/components-global/layout/SlideInPanel.vue'
import SlideInBaseTemplate from '@v/components-global/layout/SlideInBaseTemplate.vue'
import {
  propIfScheduled,
  paseBoolIfScheduled,
  parseDefaultTimeslotDuration,
} from './displayResourceUtil.js'

export default {
  name: 'ResourceSlideInPanel',
  components: { SlideInPanel, SlideInBaseTemplate },
  props: {
    focusedItem: Object,
    sidePanelIsOpen: Boolean,
    allowEdit: Boolean,
  },
  computed: {
    capacity() {
      return propIfScheduled('Capacity')(this.focusedItem)
    },
    exclusive() {
      if (this.focusedItem.Exclusivity === 'None') {
        return 'No'
      }
      return this.focusedItem.Exclusivity
    },
    allowsScheduling() {
      return paseBoolIfScheduled('AllowsScheduling')(this.focusedItem)
    },
    defaultTimeslotDuration() {
      return parseDefaultTimeslotDuration(this.focusedItem)
    },
  },
}
</script>
